import type { TFunction } from 'i18next';

/** Sıklığın ekran metni (dile göre; ADR 0128 §4). */
export function frequencyLabel(
  t: TFunction,
  frequency: { kind: string; months: number | null },
): string {
  return frequency.kind === 'custom'
    ? t('drills.frequency.custom', { count: frequency.months ?? 0 })
    : t(`drills.frequency.${frequency.kind}`);
}

const KIND_OF_MONTHS: Record<number, string> = {
  1: 'monthly',
  2: 'bimonthly',
  3: 'quarterly',
  6: 'semiannual',
  12: 'annual',
};

/** Planın etkin aralığı (ay) sıklık adıyla: 1 → Monthly, 3 → Quarterly, 4 → Every 4 months. */
export function intervalLabel(t: TFunction, months: number): string {
  const kind = KIND_OF_MONTHS[months];
  return frequencyLabel(t, kind ? { kind, months: null } : { kind: 'custom', months });
}
